import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
const useStyles = makeStyles({
	card: {
		boxShadow: `0 0 2px ${tokens.colorNeutralShadowAmbient},0 2px 4px ${tokens.colorNeutralShadowKey}`,
		cursor: 'pointer',
		width: '184px',
		height: '144px',
		display: 'flex',
		flexDirection: 'column',
		...shorthands.padding('0px'),
		...shorthands.borderRadius(tokens.borderRadiusSmall),
	},
	cardIcon: {
		height: '92px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	cardText: {
		display: 'inline-flex',
		alignItems: 'center',
		...shorthands.flex(1),
		justifyContent: 'center',
		...shorthands.margin(tokens.spacingVerticalNone, tokens.spacingHorizontalL),
	},
});
export default useStyles;
